import { render, staticRenderFns } from "./PostDeleteModal.vue?vue&type=template&id=412b29ce&"
import script from "./PostDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./PostDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports